import { Pipe, PipeTransform } from '@angular/core';
/*
 * Raise the value exponentially
 * Takes an exponent argument that defaults to 1.
 * Usage:
 *   value | exponentialStrength:exponent
 * Example:
 *   {{ 2 | exponentialStrength:10 }}
 *   formats to: 1024
*/
@Pipe({name: 'StreetName'})
export class StreetNamePipe implements PipeTransform {
  transform(value): any {
    let address = value.split(',');
    return address[0];
    // let permissions = JSON.parse(localStorage.getItem('permissions'));
    // if(permission == 'true') {
    //   return true;
    // }else{

    // }
  }

}
